import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { DeleteIcon, DownloadIcon } from "@/assets/svgs/icons";


interface SelectionActionBarProps {
    centerByParent?: boolean;
    selectionCount?: number;
    remove?: ((e: React.MouseEvent) => void) | (() => void);
    deSelect: () => void;
    selectAll: () => void;
    move?: () => void;
    download?: () => void;
}

const SelectionActionBar: React.FC<SelectionActionBarProps>  = (props) => {
    const { centerByParent = false, selectionCount, remove, deSelect, selectAll, move, download } = props;

    const intl = useIntl();

    const containerRef = useRef<HTMLDivElement>(null);
    const [left, setLeft] = useState<number | string>("50%");

    useEffect(() => {
        if (!centerByParent) {
            setLeft("50%");
            return;
        }

        const updatePosition = () => {
            if (!containerRef.current) {
                return;
            }
            const { left, width } = containerRef.current.getBoundingClientRect();
            setLeft(left + width / 2);
        };

        updatePosition();

        window.addEventListener("resize", updatePosition);
        return () => {
            window.removeEventListener("resize", updatePosition);
        };
    }, [centerByParent]);

    return (
        <div ref={containerRef} className="relative w-full">
            <div role="toolbar"
                 aria-label="selection actions"
                 className={classNames(
                     "fixed bottom-4 p-4 pl-8 flex z-[1000]",
                     "transition-opacity -translate-x-1/2 duration-300",
                     "bg-black rounded-full text-[14px] font-[400] text-white leading-[1.2] whitespace-nowrap",
                     selectionCount === 0 ? "hidden" : "block opacity-80"
                 )}
                 style={{ left }}
            >
                <span className="tabular-nums font-[600] text-right">
                    {selectionCount}
                </span>
                {intl.formatMessage({ id: "i00066" })}
                <div className="mx-8 flex gap-5">
                    <button onClick={selectAll}>
                        {intl.formatMessage({ id: "i00067" })}
                    </button>
                    <button onClick={deSelect}>
                        {intl.formatMessage({ id: "i00068" })}
                    </button>
                </div>
                {remove && (
                    <div className="px-4 border-l border-white">
                        <button className="flex items-center gap-1.5"
                                onClick={remove}
                        >
                            <DeleteIcon className="size-3.5" />
                            {intl.formatMessage({ id: "b0008" })}
                        </button>
                    </div>
                )}
                {move && (
                    <div className="px-6 border-l border-white">
                        <button onClick={move}>
                            {intl.formatMessage({ id: "i00069" })}
                        </button>
                    </div>
                )}
                {download && (
                    <div className="px-4 border-l border-white">
                        <button className="flex items-center gap-1.5"
                                onClick={download}
                        >
                            <DownloadIcon className="size-3.5" />
                            {intl.formatMessage({ id: "b0005" })}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectionActionBar;
